import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { FormattedMessage } from "react-intl";
import CircularProgressBar from "./CircularProgressBar";

export function ProgressBarBlock(props) {
  const className = `${style.titleBlock} ${props.className}`;

  const getAdjustedMaxProgress = (maxProgress) => {
    const currentProgress = maxProgress;
    const invisibleItems = props.menuList.filter(
      (item) => item.visible === false
    );
    // If no items are invisible, return the current maxProgress
    if (invisibleItems.length === 0) {
      return currentProgress;
    }
    const invisibleItemsProgress = invisibleItems.reduce(
      (sum, item) => sum + item.maxProgress,
      0
    );

    return currentProgress - invisibleItemsProgress;
  };

  return (
    <div className={className}>
      {props.progress && (
        <CircularProgressBar
          menuList={props.menuList}
          progress={props.progress}
          currentProgress={props.currentProgress}
          stroke="#FAAC48"
          maxProgress={getAdjustedMaxProgress(props.maxProgress)}
        />
      )}
      <h5>
        <FormattedMessage
          id={props.title}
          defaultMessage={props.title}
          description=""
        />
      </h5>
    </div>
  );
}

ProgressBarBlock.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Main Title to display on Header [ NoteBook]
   */
  title: PropTypes.string,
  /**
   * Value of progress to be displayed or not
   */
  progress: PropTypes.bool,
  /**
   * Maximum value of progress
   */
  maxProgress: PropTypes.number,
  /**
   * Current Progress value of progress
   */
  currentProgress: PropTypes.number,
};

ProgressBarBlock.defaultProps = {
  className: "",
  title: "",
  progress: false,
  maxProgress: 0,
  currentProgress: 0,
};
